import React from 'react'

const BlobSvg = () => {
    return (
        <>
            <>
                <svg
                    width={650}
                    height={540}
                    viewBox="0 0 65 54"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M52.0001 9.39997C54.0001 12.1 53.4001 17.4 55.9001 21.6C58.5001 25.8 64.2001 29 64.1001 31.5C64.1001 34 58.2001 35.9 54.1001 37.6C50.0001 39.4 47.6001 40.9 44.2001 44.5C40.7001 48.1 36.3001 53.8 33.0001 53.6C29.8001 53.4 27.8001 47.3 21.3001 43.2C14.9001 39.1 4.00014 37 1.10014 32.3C-1.79986 27.7 3.40014 20.4 7.90014 13.9C12.5001 7.39997 16.4001 1.49997 21.8001 0.399967C27.2001 -0.800033 34.1001 2.69997 39.8001 4.59997C45.5001 6.49997 50.1001 6.69997 52.0001 9.39997Z"
                        fill="url(#paint0_linear_473_422)"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear_473_422"
                            x1="0.261719"
                            y1="53.6051"
                            x2="52.8795"
                            y2="-9.24058"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="#C5DCF1" />
                            <stop offset={1} stopColor="#fff" />
                        </linearGradient>
                    </defs>
                </svg>

            </>

        </>
    )
}

export default BlobSvg